// extracted by mini-css-extract-plugin
export var chevron = "_n2-1";
export var clickable = "_n2-0";
export var ruleRow = "_n2-2";